export default __webpack_public_path__ + "static/media/el18.f75387d9.svg";